import {Apollo} from 'apollo-angular';
import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot} from '@angular/router';

@Injectable()
export class CleanApiCacheGuard {
    constructor(private apollo: Apollo) {}

    /* istanbul ignore next */
    currentUrl(currentRoute: ActivatedRouteSnapshot) {
        return currentRoute.pathFromRoot
            .map(x => x.url)
            .reduce((acc, urls) => [...acc, ...urls], [])
            .join('/');
    }

    canDeactivate(component, currentRoute: ActivatedRouteSnapshot): Promise<boolean> {
        return this.cleanLocalCache()
            .then(() => console.debug(`[CleanApiCacheGuard] ${component ? component.constructor.name : this.currentUrl(currentRoute)}`))
            .then(() => true)
            .catch(e => {
                console.error(e);
                return true;
            });
    }

    cleanLocalCache(): Promise<any> {
        const client = this.apollo.client;

        // While queries on flight we should not clean cache
        // dirty hack but it works

        if (
            client &&
            // @ts-ignore
            client.queryManager &&
            // @ts-ignore
            client.queryManager.inFlightLinkObservables &&
            // @ts-ignore
            client.queryManager.inFlightLinkObservables.strong.size > 0
        ) {
            return Promise.resolve(true);
        }
        // @ts-ignore
        return client && client.queryManager
            ? // @ts-ignore
              client.queryManager.clearStore()
            : // if there's no query manager there's nothing to clean up
              Promise.resolve(true);
    }
}
